const keys = {
  set_conversation: "set_conversation",
  set_messages: "set_messages",
  set_conversations: "set_conversations",
  payload: "conv_payload",
  all: "conv_all",
};

export default keys;
